import {
  User_ListUsers,
  User_PromoteToSupervisor,
  User_DemoteToUser,
  User_UpdateUserStatisticsPermission,
  User_UpdateUserEditorPermission,
} from './backend'

const list = async () => {
  let {data} = await User_ListUsers()
  return data
}

const promoteToSupervisor = async userName => {
  let {data} = await User_PromoteToSupervisor({
    cmd: {
      userName: userName,
    },
  })
  return data
}
const demoteToUser = async userName => {
  let {data} = await User_DemoteToUser({
    cmd: {
      userName: userName,
    },
  })
  return data
}

const changeStatisticsSettings = async (userName, type) => {
  let {data} = await User_UpdateUserStatisticsPermission({
    cmd: {
      userName: userName,
      state: type,
    },
  })
  return data
}

const changeEditorSettings = async (userName, type) => {
  let {data} = await User_UpdateUserEditorPermission({
    cmd: {
      userName: userName,
      state: type,
    },
  })
  return data
}

export default {
  list,
  promoteToSupervisor,
  demoteToUser,
  changeStatisticsSettings,
  changeEditorSettings,
}
